import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "loading", "dimensionPanel"]

  showGenerating() {
    this.contentTarget.classList.add('hidden')
    this.loadingTarget.classList.remove('hidden')
    this.loadingTarget.classList.add('flex')
  }

  switchDimension(event) {
    const selected = event.target.value
    this.dimensionPanelTargets.forEach((panel) => {
      panel.classList.toggle('hidden', panel.dataset.dimensionId !== selected)
    })
  }
}
